/* Premium bundle builder: toggle add-ons, live total, add main + selected to cart via AJAX Cart API. */
(function () {
  function init(el) {
    var cur = el.dataset.pmCurrency || 'USD';
    var fmt;
    try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }); }
    catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
    var mainPrice = parseFloat(el.dataset.mainPrice) || 0;
    var mainVar = el.dataset.mainVariant;
    var totalEl = el.querySelector('[data-pm-total]');
    var subEl = el.querySelector('[data-pm-sub]');
    var addEl = el.querySelector('[data-pm-add]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    root = root.replace(/\/$/, '');

    function selected() {
      var items = [{ id: mainVar, quantity: 1 }];
      el.querySelectorAll('.pm-addon.pm-sel').forEach(function (a) {
        items.push({ id: a.dataset.variant, quantity: 1 });
      });
      return items;
    }
    function recalc() {
      var total = mainPrice, count = 1;
      el.querySelectorAll('.pm-addon.pm-sel').forEach(function (a) { total += parseFloat(a.dataset.price) || 0; count++; });
      if (totalEl) totalEl.textContent = fmt.format(total / 100);
      if (subEl) subEl.textContent = (count > 1 ? count + ' items selected' : 'Main item only') + '. Estimated total, final price shown at cart.';
      if (addEl) addEl.textContent = 'Add ' + count + ' item' + (count > 1 ? 's' : '') + ' to cart';
    }
    el.querySelectorAll('.pm-addon').forEach(function (a) {
      a.addEventListener('click', function () { a.classList.toggle('pm-sel'); recalc(); });
    });
    if (addEl) addEl.addEventListener('click', function () {
      var label = addEl.textContent;
      addEl.disabled = true; addEl.textContent = 'Adding...';
      fetch(root + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: selected() })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      }).then(function () {
        window.location.href = root + '/cart';
      }).catch(function (err) {
        addEl.disabled = false; addEl.textContent = label;
        alert((err && err.description) || 'Sorry, that could not be added to the cart. Please try again.');
      });
    });
    recalc();
  }
  function boot() { document.querySelectorAll('[data-pm-bundle]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
